import { Layer } from 'const';
import { CarouselItem } from 'containers/Layouts/sagas/addCarousel';
import * as Models from 'models';
import { addReusableLayout } from './addReusableLayout';

type Results = {
  layouts: Models.LayeredLayouts;
  artboard: Models.Artboard;
  newImages: Models.Images;
  relations: Models.LayeredRelations;
  documents: Models.CombinedDocuments;
};

export function addReusableLayoutToArtboard(
  layoutDocument: Models.ReusableLayout,
  sectionId: string,
  position: number,
  artboard: Models.Artboard,
  projectDocuments: Models.CombinedDocuments,
  layouts: Models.LayeredCombinedLayouts,
  projectBrandDefinition: Models.OnlineBrandDefinition,
  activeLayer: Layer,
  rootDocument: Models.RootDocument,
  layoutId?: string,
  adoptStyles?: boolean,
  carouselItem?: CarouselItem,
): Results {
  const {
    layout,
    newImages,
    documents,
    relations,
  } = addReusableLayout(
    layoutDocument,
    sectionId,
    projectDocuments,
    layouts,
    projectBrandDefinition,
    activeLayer,
    rootDocument,
    layoutId,
    adoptStyles,
    carouselItem,
  );

  artboard.layoutIds.splice(position, 0, layout.id);

  return {
    artboard,
    newImages,
    documents,
    relations,
    layouts: { [layout.id]: layout },
  };
}
